import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SaveOutlined } from '@ant-design/icons';
import { translate } from '@smovilgps/optimus-intl';
import { Alert, Form, Modal } from 'antd-v6';
import { useAppToast } from '../../components/AppToastProvider';
import { StripePlans } from '../stripeRoutes/entities/stripePlans.entity';
import AddOrEditForm from './AddOrEditForm';
import StripePlansService from './stripePlan.service';

type Props = {
	showModal: boolean;
	title: string;
	onCancel: () => void;
	stripePlan: StripePlans | null;
	retrieveStripePlans: () => void;
};

const AddOrEditModal = ({ showModal, title, onCancel, stripePlan, retrieveStripePlans }: Props) => {
	const intl = useIntl();
	const toast = useAppToast();
	const [form] = Form.useForm();
	const [isSaving, setIsSaving] = useState<boolean>(false);

	useEffect(() => {
		if (showModal) {
			if (stripePlan) {
				form.setFieldsValue({
					...stripePlan,
					...stripePlan.price,
					amount: stripePlan.price?.amount != null ? stripePlan.price.amount / 100 : undefined,
				});
			} else {
				form.resetFields();
			}
		}
	}, [showModal, stripePlan]);

	const onOk = async () => {
		try {
			setIsSaving(true);
			const values = await form.validateFields();
			if (stripePlan) {
				await StripePlansService.editStripePlan(stripePlan.id, values);
			} else {
				await StripePlansService.addStripePlan(values);
			}
			retrieveStripePlans();
			onCancel();
		} catch (error) {
			toast.error();
		} finally {
			setIsSaving(false);
		}
	};

	return (
		<Modal
			className="manageModal"
			open={showModal}
			title={title}
			onOk={onOk}
			confirmLoading={isSaving}
			okText={
				<>
					<SaveOutlined /> <FormattedMessage {...translate('save')} />
				</>
			}
			onCancel={onCancel}
			cancelText={intl.formatMessage(translate('cancel'))}
			destroyOnHidden
		>
			{stripePlan?.hasSubscription && (
				<Alert
					title={intl.formatMessage(translate('planEditRestricted'))}
					type="info"
					style={{ marginBottom: 16 }}
					showIcon
				/>
			)}
			<Form form={form} preserve={false} layout={'vertical'} className="login-form col-8">
				<AddOrEditForm hasSubscription={stripePlan?.hasSubscription ? true : false} />
			</Form>
		</Modal>
	);
};

export default AddOrEditModal;
